import {resources, scopes} from '../../permissions/dictionary';
import {paths} from '../../dictionaries/urls';
import {filterByPermissions} from './helpers';


export const wtsOut = [
  {
    'name': 'Catálogos',
    'path': paths.WtsCatalogs,
    'resource': resources.WtsCatalogos,
    'scopes': [scopes.See],
    'icon': 'partsSearch',
  },
  {
    'name': 'Cursos',
    'path': paths.WtsCourses,
    'resource': resources.WtsCursos,
    'scopes': [scopes.See],
    'icon': 'partsSearch',
  },
  {
    'name': 'Participantes',
    'path': paths.WtsEmployees,
    'resource': resources.WtsEmpleados,
    'scopes': [scopes.See],
    'icon': 'partsSearch',
  },
  {
    'name': 'Participantes Gestor',
    'path': paths.WtsEmployeesGestor,
    'resource': resources.WtsEmpleadosGestor,
    'scopes': [scopes.See],
    'icon': 'partsSearch',
  },
];

export const wtsOutProcesos = [
  {
    'name': 'Programación',
    'path': paths.WtsCalendario,
    'resource': resources.WtsCalendario,
    'scopes': [scopes.See],
    'icon': 'partsSearch',
  },
  {
    'name': 'Programación',
    'path': paths.WtsCalendario,
    'resource': resources.WtsMatricula,
    'scopes': [scopes.See],
    'icon': 'partsSearch',
  },
  {// cambio jc
    'name': 'Registro Servicio',
    'path': paths.WtsRegistroTrabajoAgencias,
    'resource': resources.WtsRegistroTrabajoAgencias,
    'scopes': [scopes.See],
    'icon': 'partsSearch',
  },
];

export const getWtsOutcomeOptions = (permissions) => {
  const options = [{
    'name': 'Mantenimiento',
    'options': filterByPermissions(permissions, wtsOut),
  }];

  return options.filter((item) => item.options.length);
};

export const getWtsOptions = (permissions) => {
  const options = [
    {
      'name': 'Entrada',
      'options': getWtsOutcomeOptions(permissions),
    }];
  
  return options.filter((item) => item.options.length);
};


export const wtsOptions = [
  ...wtsOut,
  ...wtsOutProcesos,
];
